export const OVERLAY_NAMES = {
  LINGUIST_AVAILABILITY_EDIT: "LINGUIST_AVAILABILITY_EDIT",

  REQUESTOR_NEW_EDIT: "REQUESTOR_NEW_EDIT",
  REQUESTOR_MERGE: "REQUESTOR_MERGE",
  REQUESTOR_ACTION_EDIT: "REQUESTOR_EDIT",
  REQUESTOR_ACTION_NEW: "REQUESTOR_NEW",

  REQUESTOR_GROUP_NEW_EDIT: "REQUESTOR_GROUP_NEW_EDIT",
  REQUESTOR_GROUP_ACTION_EDIT: "REQUESTOR_GROUP_EDIT",
  REQUESTOR_GROUP_ACTION_NEW: "REQUESTOR_GROUP_NEW",

  CONTACT_PERSON_NEW_EDIT: "CONTACT_PERSON_NEW_EDIT",
  CONTACT_PERSON_MERGE: "CONTACT_PERSON_MERGE",
  CONTACT_PERSON_ACTION_EDIT: "CONTACT_PERSON_EDIT",
  CONTACT_PERSON_ACTION_NEW: "CONTACT_PERSON_NEW",

  RATE_NEW_EDIT: "RATE_NEW_EDIT",
  RATE_ACTION_EDIT: "RATE_EDIT",
  RATE_ACTION_NEW: "RATE_NEW",

  CLIENT_PROFILE: "CLIENT_PROFILE",
  CLIENT_NEW_EDIT: "CLIENT_NEW_EDIT",
  CLIENT_ACTION_EDIT: "CLIENT_EDIT",
  CLIENT_ACTION_NEW: "CLIENT_NEW",
  CLIENT_MERGE: "CLIENT_MERGE",
  // 2026-10-30 — the old Dashboard's client figures, now beside the list.
  CLIENT_STATS: "CLIENT_STATS",

  LINGUIST_NEW_EDIT: "LINGUIST_NEW_EDIT",
  LINGUIST_ACTION_EDIT: "LINGUIST_EDIT",
  LINGUIST_ACTION_NEW: "LINGUIST_NEW",
  LINGUIST_MERGE: "LINGUIST_MERGE",
  // 2026-10-30 — the old Dashboard's linguist figures, now beside the list.
  LINGUIST_STATS: "LINGUIST_STATS",
  LINGUIST_RATE_UPDATE: "LINGUIST_RATE_UPDATE",
  LINGUIST_DOCUMENT_GENERATION: "LINGUIST_DOCUMENT_GENERATION",
  LINGUISTS_GENERATED_DOCUMENTS: "LINGUISTS_GENERATED_DOCUMENTS",
  LINGUIST_PORTAL_PROFILE_EDIT: "LINGUIST_PORTAL_PROFILE_EDIT",
  LINGUIST_PORTAL_NOTIFICATION_SETTINGS_EDIT:
    "LINGUIST_PORTAL_NOTIFICATION_SETTINGS_EDIT",

  LINGUIST_ASSIGNMENT_FINALIZE: "LINGUIST_ASSIGNMENT_FINALIZE",

  SERVICE_NOTE_NEW_EDIT: "SERVICE_NOTE_NEW_EDIT",
  SERVICE_NOTE_ACTION_EDIT: "SERVICE_NOTE_EDIT",
  SERVICE_NOTE_ACTION_NEW: "SERVICE_NOTE_NEW",

  CLIENT_NOTE_NEW_EDIT: "CLIENT_NOTE_NEW_EDIT",
  CLIENT_NOTE_ACTION_EDIT: "CLIENT_NOTE_EDIT",
  CLIENT_NOTE_ACTION_NEW: "CLIENT_NOTE_NEW",

  LINGUIST_NOTE_NEW_EDIT: "LINGUIST_NOTE_NEW_EDIT",
  LINGUIST_NOTE_ACTION_EDIT: "LINGUIST_NOTE_EDIT",
  LINGUIST_NOTE_ACTION_NEW: "LINGUIST_NOTE_NEW",

  SERVICE_CHANGE_CATEGORY: "SERVICE_CHANGE_CATEGORY",

  INTERPRETATION_NEW_EDIT: "INTERPRETATION_NEW_EDIT",
  INTERPRETATION_PRE_ASSIGN: "INTERPRETATION_PRE_ASSIGN",
  INTERPRETATION_OUTREACH: "INTERPRETATION_OUTREACH",
  INTERPRETATION_OPI_UPLOAD: "INTERPRETATION_OPI_UPLOAD",
  INTERPRETATION_SEND_DETAILS: "INTERPRETATION_SEND_DETAILS",
  INTERPRETATION_REMINDERS: "INTERPRETATION_REMINDERS",
  INTERPRETATION_ACTION_EDIT: "INTERPRETATION_EDIT",
  INTERPRETATION_ACTION_NEW: "INTERPRETATION_NEW",
  INTERPRETATION_ACTION_OPI_UPLOAD: "INTERPRETATION_OPI_UPLOAD",
  INTERPRETATION_ACTION_COMPLETE: "INTERPRETATION_COMPLETE",

  TRANSLATION_NEW_EDIT: "TRANSLATION_NEW_EDIT",
  TRANSLATION_DOCUMENTS: "TRANSLATION_DOCUMENTS",
  TRANSLATION_ACTION_EDIT: "TRANSLATION_EDIT",
  TRANSLATION_ACTION_NEW: "TRANSLATION_NEW",
  TRANSLATION_ACTION_COMPLETE: "TRANSLATION_COMPLETE",

  INVOICES_NEW_EDIT: "INVOICES_NEW_EDIT",
  INVOICES_ACTION_EDIT: "INVOICES_EDIT",
  INVOICES_ACTION_NEW: "INVOICES_NEW",
  INVOICES_ACTION_COMPLETE: "INVOICES_COMPLETE",
  INVOICES_EXPORT: "INVOICES_EXPORT",

  OTHERSERVICE_NEW_EDIT: "OTHERSERVICE_NEW_EDIT",
  OTHERSERVICE_ACTION_EDIT: "OTHERSERVICE_EDIT",
  OTHERSERVICE_ACTION_NEW: "OTHERSERVICE_NEW",
  OTHERSERVICE_ACTION_COMPLETE: "OTHERSERVICE_COMPLETE",

  CALENDAR_SYNC_VERIFY: "CALENDAR_SYNC_VERIFY",

  TASK_NEW_EDIT: "TASK_NEW_EDIT",
  TASK_ACTION_EDIT: "TASK_EDIT",
  TASK_ACTION_NEW: "TASK_NEW",
  TASK_PROFILE: "TASK_PROFILE",
  TASKS_AUTOMATED: "TASKS_AUTOMATED",

  MEMBER_PROFILE: "MEMBER_PROFILE",
  MEMBER_NEW_EDIT: "MEMBER_NEW_EDIT",
  MEMBER_ACTION_EDIT: "MEMBER_EDIT",
  MEMBER_ACTION_NEW: "MEMBER_NEW",

  SETTINGS_PROFILE_EDIT: "SETTINGS_PROFILE_EDIT",
  SETTINGS_LANGUAGE_NEW_EDIT: "SETTINGS_LANGUAGE_NEW_EDIT",
  SETTINGS_DIALECT_NEW_EDIT: "SETTINGS_DIALECT_NEW_EDIT",
  SETTINGS_EMAIL_TEMPLATE_NEW_EDIT: "SETTINGS_EMAIL_TEMPLATE_NEW_EDIT",
  SETTINGS_MILEAGE_RATE_NEW_EDIT: "SETTINGS_MILEAGE_RATE_NEW_EDIT",
  SETTINGS_UNIT_NEW_EDIT: "SETTINGS_UNIT_NEW_EDIT",
  SETTINGS_HOLIDAY_NEW_EDIT: "SETTINGS_HOLIDAY_NEW_EDIT",
  SETTINGS_LINGUIST_REQUIREMENT_NEW_EDIT:
    "SETTINGS_LINGUIST_REQUIREMENT_NEW_EDIT",
  SETTINGS_DOCUMENT_TEMPLATE_NEW_EDIT: "SETTINGS_DOCUMENT_TEMPLATE_NEW_EDIT",
  SETTINGS_SERVICE_DOCUMENT_NEW_EDIT: "SETTINGS_SERVICE_DOCUMENT_NEW_EDIT",
  SETTINGS_DOCUMENT_CATEGORIES_MANAGER:
    "SETTINGS_DOCUMENT_CATEGORIES_MANAGER",
  SETTINGS_PAYMENT_METHOD_NEW_EDIT: "SETTINGS_PAYMENT_METHOD_NEW_EDIT",
  SETTINGS_SERVICE_TYPE_NEW_EDIT: "SETTINGS_SERVICE_TYPE_NEW_EDIT",
  SETTINGS_SERVICE_COST_TYPE_NEW_EDIT: "SETTINGS_SERVICE_COST_TYPE_NEW_EDIT",
  SETTINGS_SERVICE_COST_TYPE_RULES_EDIT: "SETTINGS_SERVICE_COST_TYPE_RULES_EDIT",
  SETTINGS_NOTIFICATION_NEW_EDIT: "SETTINGS_NOTIFICATION_NEW_EDIT",

  SETTINGS_EXPENSES_CATEGORY_NEW_EDIT: "SETTINGS_EXPENSES_CATEGORY_NEW_EDIT",
  SETTINGS_EXPENSES_SUBCATEGORY_NEW_EDIT:
    "SETTINGS_EXPENSES_SUBCATEGORY_NEW_EDIT",
  SETTINGS_TIMESHEETS_MANUAL_NEW: "SETTINGS_TIMESHEETS_MANUAL_NEW",
  SETTINGS_TIMESHEETS_IMPORT: "SETTINGS_TIMESHEETS_IMPORT",
  MANAGEMENT_EXPENSE_NEW_EDIT: "MANAGEMENT_EXPENSE_NEW_EDIT",
  MANAGEMENT_VIDEO_NEW_EDIT: "MANAGEMENT_VIDEO_NEW_EDIT",
  VIDEO_ACTION_NEW: "VIDEO_NEW",
  VIDEO_ACTION_EDIT: "VIDEO_EDIT",
  EXPENSE_PROFILE: "EXPENSE_PROFILE",
  GLOBAL_SEARCH: "GLOBAL_SEARCH",
  REPORTS_INSIGHTS: "REPORTS_INSIGHTS",
  OVERLAY_SHOWCASE: "OVERLAY_SHOWCASE",
};
